import { HeroSection } from "@/components/ui/hero-section-1";

export default function Landing() {
  return <HeroSection />;
}